import { CLOSE_NOTIFICATION, defaultState, DISPLAY_NOTIFICATION } from 'notification/constants';

const notificationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case DISPLAY_NOTIFICATION: {
      const isPermissionToast = action.isPermissionToast === true;
      const addNotification = {
        messageText: action.msgText ? action.msgText : '',
        type: action.notificationType ? action.notificationType : 'error',
        showCloseBtn: action.showCloseBtn !== undefined ? action.showCloseBtn : true,
        id: action.id ? action.id : state.listOfNotifications.length + 1,
        delayTime: action.delayTime,
        timestamp: action.timestamp,
        autoDismissTime: action.autoDismissTime,
        isPermissionToast,
      };
      const newNotificationList = [];

      const existing = isPermissionToast ? state.listOfNotifications.filter((notification) => !notification.isPermissionToast) : state.listOfNotifications.slice();
      newNotificationList.push(addNotification);
      //  Display only the newest 5 messages
      const notificationLimit = existing.length > 4 ? 4 : existing.length;
      for (let i = 0; i < notificationLimit; i += 1) {
        newNotificationList.push(existing[i]);
      }
      const noDuplicateMsg = [...new Map(newNotificationList.map((o) => [o.messageText, o])).values()];
      return {
        ...state,
        listOfNotifications: noDuplicateMsg,
      };
    }
    case CLOSE_NOTIFICATION: {
      let newNotificationList = state.listOfNotifications.slice();
      newNotificationList = newNotificationList.filter((x) => x.id !== action.id);
      return {
        ...state,
        listOfNotifications: newNotificationList,
      };
    }
    default:
      return state;
  }
};

export default notificationReducer;
